import React, { Component } from "react";
import Login from "../../../components/Login/Login";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : LoginForm
Description : Componente que contienen la primera parte del formulario, definida previamente en la carpeta Components
Date Autor Modification
================================================================================
1/10/2021 Cristian Andres Pizo Mina – Se llama al componente Login
================================================================================ */
class LoginForm extends Component{
    render(){
        return(
            <Login/>  
        )   
    }
}

export default LoginForm;